<template>
    <vxe-modal
        v-model="isShow"
        :title="title"
        width="1100"
        height="640"
        show-zoom
        resize
        fullscreen
    >
        <div>
            <div>
                <vxe-form :data="toolbar.formData">
                    <vxe-form-item title="课程名称" field="course_name">
                        <template #default="{ data }">
                            <vxe-input
                                v-model="data.course_name"
                                placeholder="全部"
                                readonly
                            ></vxe-input>
                        </template>
                    </vxe-form-item>

                    <vxe-form-item title="关键字" field="searchKey">
                        <template #default="{ data }">
                            <vxe-input
                                v-model="data.searchKey"
                                placeholder="请输入关键字"
                                clearable
                            ></vxe-input>
                        </template>
                    </vxe-form-item>

                    <vxe-form-item>
                        <template #default>
                            <vxe-button
                                status="primary"
                                @click="findData"
                                @keyup.enter="findData"
                                >查询</vxe-button
                            >
                            <vxe-button @click="clear">重置</vxe-button>
                            <vxe-button @click="exportDataEvent"
                                >导出</vxe-button
                            >
                        </template>
                    </vxe-form-item>
                </vxe-form>
            </div>
            <div style="overflow: hidden; height: 100%">
                <vxe-table
                    stripe
                    class="mytable-scrollbar"
                    :data="tableData"
                    :height="tableHeight"
                    show-overflow
                    :row-config="{
                        height: 36,
                        isHover: true,
                        isCurrent: true,
                    }"
                    ref="xTable1"
                >
                    <vxe-column
                        type="seq"
                        field="id"
                        title="序号"
                        width="50"
                    ></vxe-column>
                    <vxe-column
                        field="class_no"
                        title="班级编号"
                        width="120"
                        show-overflow
                        resizable
                        sortable
                    ></vxe-column>
                    <vxe-column
                        field="class_name"
                        title="班级名称"
                        width="140"
                        show-overflow
                        resizable
                        sortable
                    ></vxe-column>
                    <vxe-column
                        field="course_no"
                        title="课程编号"
                        width="120"
                        show-overflow
                        resizable
                        sortable
                    ></vxe-column>
                    <vxe-column
                        field="course_name"
                        title="课程名称"
                        width="180"
                        show-overflow
                        resizable
                        sortable
                    ></vxe-column>
                    <vxe-column
                        field="student_id"
                        title="学员ID"
                        width="100"
                        show-overflow
                        resizable
                        sortable
                    ></vxe-column>
                    <vxe-column
                        field="student_name"
                        title="学员姓名"
                        width="100"
                        show-overflow
                        resizable
                        sortable
                    ></vxe-column>
                    <vxe-column
                        field="superior"
                        title="直属上级"
                        width="100"
                        show-overflow
                        resizable
                        sortable
                    ></vxe-column>
                    <vxe-column
                        field="signin_no"
                        title="签到编号"
                        width="140"
                        show-overflow
                        resizable
                        sortable
                    ></vxe-column>
                    <vxe-column
                        field="signin_time"
                        title="签到时间"
                        width="160"
                        show-overflow
                        resizable
                        sortable
                    ></vxe-column>
                    <vxe-column
                        field="course_start"
                        title="面授开始时间"
                        width="160"
                        show-overflow
                        resizable
                        sortable
                    ></vxe-column>
                    <vxe-column
                        field="course_end"
                        title="面授结束时间"
                        width="160"
                        show-overflow
                        resizable
                        sortable
                    ></vxe-column>
                </vxe-table>
            </div>
            <div>
                <vxe-pager
                    background
                    v-model:current-page="tablePager.currentPage"
                    v-model:page-size="tablePager.pageSize"
                    :total="tablePager.totalResult"
                    @page-change="handlePageChange"
                    :page-sizes="[
                        10,
                        20,
                        100,
                        { label: '全部数据', value: 10000 },
                    ]"
                    :layouts="[
                        'PrevJump',
                        'PrevPage',
                        'JumpNumber',
                        'NextPage',
                        'NextJump',
                        'Sizes',
                        'FullJump',
                        'Total',
                    ]"
                >
                </vxe-pager>
            </div>
        </div>
    </vxe-modal>
</template>

<script setup>
import {
    reactive,
    ref,
    getCurrentInstance,
    defineExpose,
    defineEmits,
} from "vue";
import { VXETable } from "vxe-table";
import Qs from "qs";

const { proxy } = getCurrentInstance();
const emit = defineEmits(["flashList"]);
const tableHeight = ref(600);
const tableData = ref([]);

const tablePager = reactive({
    currentPage: 1,
    pageSize: 10,
    totalResult: 0,
});

const toolbar = reactive({
    loading: false,
    formData: {
        course_name: "",
        course_id: "",
        searchKey: "",
    },
});

const findData = () => {
    const params = {
        uid: proxy.$store.state.userID,
        email: proxy.$store.state.email,
        currentPage: tablePager.currentPage,
        pageSize: tablePager.pageSize,
        searchKey: [
            toolbar.formData.course_id,
            toolbar.formData.searchKey,
        ],
    };
    proxy.$api.courseManageAPI
        .getCourseSignInList(Qs.stringify(params))
        .then((res) => {
            if (res.data.Success == false) {
                VXETable.modal.message({
                    content: res.data.Message,
                    status: "error",
                });
                return;
            }
            tableData.value = res.data.Data.dataTable;
            tablePager.currentPage = res.data.Data.currentPage;
            tablePager.pageSize = res.data.Data.pageSize;
            tablePager.totalResult = res.data.Data.totalResult;
            tableHeight.value = calTableHeight(res.data.Data.dataTable.length);
        })
        .catch((error) => {
            console.log(error);
        });
};

const handlePageChange = (params) => {
    tablePager.currentPage = params.currentPage;
    tablePager.pageSize = params.pageSize;
    findData();
};

const calTableHeight = (rowsLength) => {
    let minHeight = window.innerHeight - (65 + 28 + 198);
    let calHeight = rowsLength == null ? 0 : (rowsLength + 1) * 36 + 22;
    return Math.max(450, calHeight);
};

const clear = () => {
    toolbar.formData.searchKey = "";
};
const exportDataEvent = () => {
    const $table = proxy.$refs.xTable1;
    $table.exportData({ type: "csv" });
};

const isShow = ref(false);
const title = ref("培训签到列表");
const openModal = async (row) => {
    isShow.value = true;
    tablePager.currentPage = 1;
    toolbar.formData.course_name = row.course_name || "";
    toolbar.formData.course_id = row.id || "";
    toolbar.formData.searchKey = "";
    findData();
};

defineExpose({ openModal });
</script>

<style lang="scss" scoped>
.mytable-style .vxe-body--column.col-red {
    background-color: red;
    color: #fff;
}

.active {
    color: green;
}

.error {
    color: red;
}

.audit {
    color: blue;
}
</style>

<style type="text/css">
td.vxe-body--column {
    vertical-align: middle;
}
</style>
